// src/content/transcripts/episode52.de.js
// Transcript data for Episode 52 of berggesundheit podcast

export const episode52 = {
  meta: {
    episodeNumber: 52,
    podcastName: 'berggesundheit',
    host: 'Tobias Berg',
    duration: '1:14:32',
    title: 'Reinkarnation: Was, wenn der Tod nicht das Ende ist?',
    description: 'Benjamin Kurtz im ausführlichen Gespräch über Seelenrückführung, Reinkarnation und was wirklich in einer Session passiert.',
    airDate: '2024',
  },

  transcript: [
    {
      speaker: "Tobias Berg",
      text: "Herzlich willkommen zu Episode 52 von berggesundheit. Heute habe ich einen Gast, der sich mit einem Thema beschäftigt, das viele fasziniert, aber auch viele skeptisch macht: Seelenrückführung und Past Life Regression. Benjamin Kurtz, schön, dass du da bist."
    },
    {
      speaker: "Benjamin Kurtz",
      text: "Danke, Tobias. Ich freue mich sehr, über dieses Thema sprechen zu können – weil es so viele Missverständnisse gibt, und gleichzeitig so viele Menschen, die tiefe Erfahrungen damit gemacht haben."
    },
    {
      speaker: "Tobias Berg",
      text: "Lass uns mit einer ganz grundlegenden Frage beginnen: Was ist Seelenrückführung überhaupt? Was passiert da konkret?"
    },
    {
      speaker: "Benjamin Kurtz",
      text: "Seelenrückführung ist im Grunde ein hypnotischer Prozess, in dem du in einen tiefen Entspannungszustand geführt wirst – und in diesem Zustand können Erinnerungen auftauchen, die scheinbar nicht aus diesem Leben stammen. Manchmal sind es Bilder, manchmal Gefühle, manchmal ganze Szenen. Die zentrale Frage dabei ist nicht: Ist das wirklich ein früheres Leben? Sondern: Was zeigt mir das über mein jetziges Leben?"
    },
    {
      speaker: "Tobias Berg",
      text: "Das klingt faszinierend. Aber ich glaube, viele Zuhörer werden jetzt denken: Das ist doch einfach Einbildung oder Fantasie..."
    },
    {
      speaker: "Benjamin Kurtz",
      text: "Das ist eine sehr berechtigte Frage. Und ehrlich gesagt: Ian Stevenson an der University of Virginia hat über 2.500 Fälle dokumentiert – Kinder, die spontan von früheren Leben berichteten, mit verifizierbaren Details. Das sind keine Sitzungen, keine Hypnose – das sind Kinder, die einfach anfangen zu erzählen. Jim Tucker, sein Nachfolger, arbeitet bis heute daran. Die Forschung ist real, auch wenn sie in der Breite kaum wahrgenommen wird."
    },
    {
      speaker: "Tobias Berg",
      text: "Was hat dich persönlich dazu gebracht, diese Arbeit zu machen?"
    },
    {
      speaker: "Benjamin Kurtz",
      text: "Ein Erlebnis in einem langen Coaching-Tag. Nach fast zehn Stunden Arbeit führte mich eine Session in etwas, das sich wie ein früheres Leben anfühlte. Was danach passierte – das Verstehen von Mustern, die ich jahrelang nicht greifen konnte – das hat mich tief berührt. Nicht intellektuell. Durch direktes Erleben. Und da wusste ich: Das ist das, womit ich arbeiten möchte."
    },
    {
      speaker: "[Platzhalter]",
      text: "Das vollständige Transkript dieser Episode wird hier eingefügt, sobald es vorliegt. Dieser Text dient als Platzhalter für die Transkript-Reader-Funktion."
    }
  ]
};

export default episode52;
